import React from "react";
import styled, {css} from "styled-components";
import typography, { rhythm } from "../utils/typography";
import presets from "../utils/presets";

const Tag = styled.span`
  background-color: ${props => props.brand ? presets.brand : presets.accent};
  padding: ${rhythm(.25)} ${rhythm(.25)};
  line-height: ${rhythm(1.25)};

  -webkit-box-decoration-break: clone;
  -ms-box-decoration-break: clone;
  -o-box-decoration-break: clone;
  box-decoration-break: clone;

  ::first-letter {
    text-transform: uppercase;
  }
`

const TagP = styled.p`
  &::first-letter {
    text-transform: uppercase;
  }
`

export default (props) => {
  return(
    <TagP><Tag {...props}>{props.children}</Tag></TagP>
  );
}



// WEBPACK FOOTER //
// ./src/com/Tag.js